export const getCompanyDetails = (companyId: number) => `/api/companies/${companyId}`;
export const getCompanyAssetSignedUrl = (companyId: number, fileType: string) =>
  `/api/companies/${companyId}/asset-signed-url/${fileType}`;

export default {
  getCompanyDetails,
  getCompanyAssetSignedUrl,
};
